import ApiClient from "@/api/ApiClient.ts";
import qs from "qs";

const state = {
  reqs: [],
};

const mutations = {
  setReqs(state, reqs) {
    state.reqs = reqs.map((item, i) => {
      item.order = i + 1;
      return item;
    });
  },
};

const actions = {
  async getReqs({ commit, rootGetters }, wgId = null) {
    const params = {
      wgId: wgId || rootGetters["app/defaultWorkgroup"].id,
    };
    try {
      const api = ApiClient();
      let response = await api.get("reqs", { params });
      const reqs = response.data.sort(function (a, b) {
        return a.order - b.order;
      });
      commit("setReqs", reqs);
    } catch (error) {
      console.error("ERROR en getReqs: ", error.message);
    }
  },

  async createReq({ rootGetters }, payload) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: payload.data });

    try {
      const api = ApiClient();
      await api.post("reqs", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
    } catch (error) {
      console.error("ERROR en createReq: ", error.message);
      return error;
    }
  },

  async updateReqs({ rootGetters }, payload) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };
    const urlFormData = qs.stringify({ values: payload.data });
    try {
      const api = ApiClient();
      await api.put("reqs", urlFormData, {
        params,
        headers: { "content-type": "application/x-www-form-urlencoded" },
      });
      return true;
    } catch (error) {
      console.error("ERROR en updateReqs: ", error.message);
    }
  },

  async deleteReq({ rootGetters }, payload) {
    const params = {
      wgId: rootGetters["app/defaultWorkgroup"].id,
      ...payload.params,
    };

    try {
      const api = ApiClient();
      await api.delete("reqs", {
        params,
      });
    } catch (error) {
      console.error("ERROR en deleteReq: ", error.message);
      return error;
    }
  },
};

const getters = {
  reqs(state) {
    return state.reqs;
  },

  reqsTaxi(state) {
    if (state.reqs) {
      return state.reqs.filter((req) => req.type === "taxi");
    }
  },

  reqsDriver(state) {
    if (state.reqsDriver) {
      return state.reqs.filter((req) => req.type === "driver");
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
